import React from "react";

import { PerformanceSummaryPage } from "@harrow-education/ui-components";

const PerformanceSummary = (props) => {
  return <PerformanceSummaryPage {...props} />;
};

export default PerformanceSummary;
